<script>
	const Q = require('q');
	const _ = require('underscore');

	const {
		fireEvent,
		events: { SKI_VIEW_RESULTS, EXPORT_CSV, NEXT_STUDENT, PREVIOUS_STUDENT }
	} = require('utilities/analyticsUtilities');

	const csvUtilities = require('utilities/csvUtilities');
	const downloadCSV = csvUtilities.downloadCSV;

	const studentKnowledgeInventoryUtilities = require('utilities/studentKnowledgeInventoryUtilities');
	const getSKIProduct = studentKnowledgeInventoryUtilities.getSKIProduct;
	const getSKIResults = studentKnowledgeInventoryUtilities.getSKIResults;
	const getSKIAssignments = studentKnowledgeInventoryUtilities.getSKIAssignments;

	module.exports = {
		components: {
			'load-mask': require('components/load-mask.vue').default,
			'info-icon': require('components/svg/info-icon.vue').default,
			pagination: require('components/pagination.vue').default
		},
		props: ['roster'],
		modelData: ['skiProduct', 'skiResults', 'skiAssignments', 'classCode'],
		data() {
			return {
				assignmentsLoading: false,
				firstResultsLoading: false,
				secondResultsLoading: false,
				productLoading: false,
				rawQuestions: [],
				firstActiveRMSID: '',
				secondActiveRMSID: '',
				resultsTab: 'students',
				selectedStudentIdx: 0
			};
		},
		computed: {
			loading() {
				return this.assignmentsLoading || this.firstResultsLoading || this.secondResultsLoading || this.productLoading;
			},
			sortedAssignments() {
				let skiAssignments = this.skiAssignments;
				let assignments = [];
				let now = Date.now() / 1000;

				if (skiAssignments && skiAssignments.length) {
					assignments = [...skiAssignments].filter(a => a.d < now).sort((a, b) => (a.c > b.c ? 1 : -1));
				}
				return assignments;
			},
			questions() {
				let product = this.skiProduct;
				let skiResults = this.skiResults;
				let rawQuestions = this.rawQuestions;
				let roster = this.roster;
				let rmsid = this.firstActiveRMSID;
				let compareRmsid = this.secondActiveRMSID;
				let questionList = [];

				if (product && skiResults && rawQuestions && roster && roster.students && rmsid && skiResults[rmsid]) {
					let results = skiResults[rmsid];
					let compareResults = null;
					if (compareRmsid && skiResults[compareRmsid]) {
						compareResults = skiResults[compareRmsid];
					}
					questionList = this.formatQuestions(results, compareResults, rawQuestions, roster);
				}
				return questionList;
			},
			selectedStudentName() {
				const roster = this.roster;
				const selectedStudentIdx = this.selectedStudentIdx;
				return (
					roster &&
					roster.students &&
					roster.students[selectedStudentIdx].firstName +
						(roster.students[selectedStudentIdx].lastName ? ' ' + roster.students[selectedStudentIdx].lastName : '')
				);
			}
		},
		watch: {
			skiProduct(product) {
				let rawQuestions = [];

				if (product && product.sections && product.sections.length) {
					product.sections.forEach(section => {
						if (section.questions && section.questions.length) {
							section.questions.forEach(question => {
								rawQuestions.push(_.assign({}, question));
							});
						}
					});
				}

				this.rawQuestions = rawQuestions;
			},
			sortedAssignments(assignments) {
				if (assignments && assignments.length) {
					this.firstActiveRMSID = assignments[0].rmsid;
					if (assignments.length > 1) {
						this.secondActiveRMSID = assignments[assignments.length - 1].rmsid;
					}
				}
			},
			firstActiveRMSID(rmsid) {
				if (rmsid) {
					this.firstResultsLoading = true;
					this.getResults(rmsid).finally(() => (this.firstResultsLoading = false));
				}
			},
			secondActiveRMSID(rmsid) {
				if (rmsid) {
					this.secondResultsLoading = true;
					this.getResults(rmsid).finally(() => (this.secondResultsLoading = false));
				}
			},
			classCode(cc) {
				if (cc) {
					this.getAssignments();
					this.productLoading = true;
					getSKIProduct().finally(() => (this.productLoading = false));
				}
			}
		},
		methods: {
			getAssignments() {
				let cc = this.classCode;
				this.assignmentsLoading = true;
				getSKIAssignments(cc).then(() => (this.assignmentsLoading = false));
			},
			getResults(rmsid) {
				let cc = this.classCode;
				let prms = Q();
				if (rmsid) {
					fireEvent(SKI_VIEW_RESULTS, {
						cc,
						rmsid
					});
					prms = getSKIResults(cc, rmsid);
				}
				return prms;
			},
			formatQuestions(results, compareResults, rawQuestions, roster) {
				let resultsTab = this.resultsTab;
				let selectedStudentIdx = this.selectedStudentIdx;
				let skiProduct = this.skiProduct;
				let questionTypes = skiProduct && skiProduct.questionTypes;

				let questions = rawQuestions.map(q => {
					let qid = q.id;
					let students = [];
					let rosterStudents = roster.students;
					let answerMap = {};

					if (resultsTab === 'response') {
						if (q.options) {
							answerMap = q.options.reduce((acc, o) => {
								acc[o.key] = {
									count: 0,
									compareCount: 0,
									value: o.text
								};
								return acc;
							}, {});
						} else if (questionTypes[q.type] && questionTypes[q.type].options) {
							let options = questionTypes[q.type].options;
							if (options && options.length) {
								options.forEach(o => {
									answerMap[o.value] = {
										count: 0,
										compareCount: 0,
										value: o.text
									};
								});
							}
						}
					}

					students = rosterStudents.reduce((acc, s, idx) => {
						if (resultsTab === 'response') {
							let ws = results[s.uid] && results[s.uid].sc;
							if (ws && typeof ws[qid] !== 'undefined' && ws[qid] !== null) {
								if (typeof ws[qid] === 'number') {
									answerMap[ws[qid]].count += 1;
								} else if (Array.isArray(ws[qid])) {
									ws[qid].forEach(key => (answerMap[key].count += 1));
								}
							}

							let cws = compareResults && compareResults[s.uid] && compareResults[s.uid].sc;
							if (cws && typeof cws[qid] !== 'undefined' && cws[qid] !== null) {
								if (typeof cws[qid] === 'number') {
									answerMap[cws[qid]].compareCount += 1;
								} else if (Array.isArray(cws[qid])) {
									cws[qid].forEach(key => (answerMap[key].compareCount += 1));
								}
							}
						} else if (resultsTab !== 'individual' || selectedStudentIdx === idx) {
							let ws = results[s.uid] && results[s.uid].sc;
							let submitted = !!ws;
							let answer = null;
							if (ws && typeof ws[qid] !== 'undefined' && ws[qid] !== null) {
								answer = this.formatAnswer(ws[qid], q);
							}

							let cws = compareResults && compareResults[s.uid] && compareResults[s.uid].sc;
							let compareSubmitted = !!cws;
							let compareAnswer = null;
							if (cws && typeof cws[qid] !== 'undefined' && cws[qid] !== null) {
								compareAnswer = this.formatAnswer(cws[qid], q);
							}

							acc.push(
								_.assign({}, s, {
									answer,
									submitted,
									compareAnswer,
									compareSubmitted
								})
							);
						}
						return acc;
					}, []);

					return _.assign({}, q, {
						students,
						answerMap
					});
				});
				return questions;
			},
			formatAnswer(answer, question) {
				let ans = '';
				let skiProduct = this.skiProduct;
				let questionTypes = skiProduct && skiProduct.questionTypes;
				let type = question.type;

				if (typeof answer !== 'undefined' && answer !== null && type) {
					if (question.options) {
						let answers = [];
						let optionMap = question.options.reduce((acc, o) => {
							acc[o.key] = o;
							return acc;
						}, {});
						if (Array.isArray(answer)) {
							answer.forEach(a => {
								if (optionMap[a] && optionMap[a].text) {
									answers.push(optionMap[a].text);
								}
							});
							ans = answers.join(', ');
						} else {
							ans = optionMap[answer];
						}
					} else if (questionTypes[type] && questionTypes[type].options) {
						let options = questionTypes[type].options;
						if (options && options.length) {
							options.every(o => {
								if (o.value === answer) {
									ans = o.text;
									return false;
								}
								return true;
							});
						}
					} else {
						ans = answer;
					}
				}

				return ans;
			},
			getChangeCount(count, compareCount) {
				let change = '<span class="text-muted">N/A<span>';

				if (count > compareCount) {
					change = '<span class="text-red">Decrease<span>';
				} else if (count < compareCount) {
					change = '<span class="text-green">Increase<span>';
				} else {
					change = '<span class="">No Change<span>';
				}

				return change;
			},
			getChange(question, student) {
				let qid = question.id;
				let skiResults = this.skiResults;
				let firstActiveRMSID = this.firstActiveRMSID;
				let secondActiveRMSID = this.secondActiveRMSID;
				let firstResults = skiResults[firstActiveRMSID];
				let secondResults = skiResults[secondActiveRMSID];
				let firstWs = firstResults[student.uid] && firstResults[student.uid].sc;
				let secondWs = secondResults[student.uid] && secondResults[student.uid].sc;

				let change = '<span class="text-muted">N/A<span>';

				if (
					firstWs &&
					typeof firstWs[qid] === 'number' &&
					firstWs[qid] !== null &&
					secondWs &&
					typeof secondWs[qid] === 'number' &&
					secondWs[qid] !== null
				) {
					if (firstWs[qid] < secondWs[qid]) {
						change = '<span class="text-red">Decrease<span>';
					} else if (firstWs[qid] > secondWs[qid]) {
						change = '<span class="text-green">Increase<span>';
					} else {
						change = '<span class="">No Change<span>';
					}
				}

				return change;
			},
			changeStudent(studentIndex, event) {
				this.selectedStudentIdx = studentIndex;

				fireEvent(event, {
					loc: 'ski-results',
					cc: this.classCode,
					suid: this.roster.students[studentIndex].uid
				});
			},
			previousStudent(studentIndex) {
				this.changeStudent(studentIndex, PREVIOUS_STUDENT);
			},
			nextStudent(studentIndex) {
				this.changeStudent(studentIndex, NEXT_STUDENT);
			},
			onStudentClick(student) {
				if (student && student.uid) {
					this.resultsTab = 'individual';
					this.roster.students.some((s, idx) => {
						if (s.uid === student.uid) {
							this.selectedStudentIdx = idx;
							return true;
						}
						return false;
					});
				}
			},
			onPrintClick() {
				window.print();
			},
			getAnswerText(student) {
				let answer = student.answer;

				if (!answer) {
					answer = 'Not answered';
				}

				if (!student.submitted) {
					answer = 'Not submitted';
				}

				return answer;
			},
			getStudentsExportData(fN, className) {
				const fileName = fN + '_Students';
				let data = [['Class', className], [], ['Students']];
				const questionRowIndex = 2; //Append to ['Students']
				const bufferRows = data.length;

				const { studentRows, studentIndexMap } = this.roster.students.reduce(
					(acc, { firstName, lastName, uid }, studentIndex) => {
						acc.studentIndexMap[uid] = studentIndex + bufferRows;
						acc.studentRows.push([`${firstName} ${lastName || ''}`]);
						return acc;
					},
					{ studentRows: [], studentIndexMap: {} }
				);

				data = data.concat(studentRows);

				data = this.questions.reduce((acc, question, index) => {
					acc[questionRowIndex].push(`${index + 1}. ${question.text}`);

					question.students.forEach(student => {
						const answer = this.getAnswerText(student);
						acc[studentIndexMap[student.uid]].push(answer);
					});

					return acc;
				}, data);

				return {
					data,
					fileName
				};
			},
			getResponsesExportData(fN, className) {
				const fileName = fN + '_Responses';
				let data = [['Class', className], [], ['Response', 'Answer']];

				data = this.questions.reduce((acc, question, index) => {
					acc.push([`${index + 1}. ${question.text}`]);
					for (const answerKey in question.answerMap) {
						const answer = question.answerMap[answerKey];
						acc.push([answer.value, answer.count]);
					}
					acc.push([]);

					return acc;
				}, data);

				return {
					data,
					fileName
				};
			},
			getIndividualExportData(fN, className) {
				const studentName = this.selectedStudentName;
				const fileName = fN + `_${studentName.split(' ').join('_')}_Responses`;
				let data = [['Class', className], ['Student', studentName], [], ['Question', 'Answer']];

				data = this.questions.reduce((acc, question, index) => {
					const questionText = `${index + 1}. ${question.text}`;
					const answer = this.getAnswerText(question.students[0]);
					acc.push([questionText, answer]);

					return acc;
				}, data);

				return {
					data,
					fileName
				};
			},
			onExportClick() {
				const roster = this.roster;
				const className = roster.name;
				const dataFnMap = {
					students: this.getStudentsExportData,
					response: this.getResponsesExportData,
					individual: this.getIndividualExportData
				};

				let fileName = `ReadWorks_RMS_${className.split(' ').join('_')}`;
				let data = [];

				({ fileName, data } = dataFnMap[this.resultsTab](fileName, className));

				fileName += '.csv';
				downloadCSV(data, fileName);

				fireEvent(EXPORT_CSV, {
					cc: this.classCode,
					rmsid: this.firstActiveRMSID
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.ski-results {
		position: relative;

		.ski-student-header {
			margin-bottom: 0.5rem;
		}

		.ski-student-answer {
			display: flex;
			align-items: center;
			padding: 0.5rem 0;
			border-bottom: 1px solid $c-grey;

			.student-name,
			.student-answer-value {
				width: 8rem;
			}

			&.ski-student-answer-header {
				font-weight: 700;
				padding: 0;

				form.validated-form.answer-column {
					select {
						margin-top: 0;
					}
				}
			}

			.answer-column,
			.change-column,
			.student-choice {
				flex-basis: 12rem;
			}
		}

		.ski-student-answer-header {
			border-bottom: none;
		}

		&.students {
			.ski-student-header {
				margin-top: 1rem;
			}
		}

		&.individual {
			.student-name {
				display: none;
			}

			.individual-student-tools {
				display: flex;
				align-items: center;

				.individual-student-name {
					flex: 1;
				}
			}
		}

		&.response {
			.ski-student-answer-header.column-headers {
				margin-top: 1rem;
			}
			.student-choice {
				text-align: center;
			}
		}

		&.single {
			.second-answer-column,
			.change-column,
			.assessment-select {
				display: none;
			}
		}

		.results-tools {
			display: flex;
			align-items: center;

			.toggle-wrapper {
				flex: 1;
			}

			button {
				margin: 0 0.125rem;
			}
		}
	}

	@media print {
		.ski-results {
			.ski-question {
				page-break-inside: avoid;
			}

			&.individual .individual-student-tools {
				display: block;
			}
		}
	}
</style>
<template>
	<div :class="['ski-results', resultsTab, { single: sortedAssignments.length === 1 }]">
		<load-mask
			v-if="loading"
			class="align-top"></load-mask>
		<div class="results-tools print-hidden">
			<div class="toggle-wrapper">
				<div class="toggle-buttons toggle-buttons-left">
					<label
						class="toggle-button button -small"
						:class="{
							active: resultsTab === 'students'
						}"
						data-text="Students">
						<input
							type="radio"
							name="tab"
							value="students"
							v-model="resultsTab" />Students
					</label>
					<label
						class="toggle-button button -small"
						:class="{
							active: resultsTab === 'response'
						}"
						data-text="Response">
						<input
							type="radio"
							name="tab"
							value="response"
							v-model="resultsTab" />Response
					</label>
					<label
						class="toggle-button button -small"
						:class="{
							active: resultsTab === 'individual'
						}"
						data-text="Individual">
						<input
							type="radio"
							name="tab"
							value="individual"
							v-model="resultsTab" />Individual
					</label>
				</div>
			</div>
			<button
				class="button -small blue-outline"
				@click="onPrintClick"
				aria-label="Print">
				<i class="fa-solid fa-print fa-lg"></i>
			</button>
			<button
				class="button -small blue-outline"
				@click="onExportClick"
				aria-label="Export results">
				<i class="fa-solid fa-up-right-from-square fa-lg"></i>
			</button>
		</div>
		<div
			v-if="resultsTab === 'individual'"
			class="individual-student-tools">
			<div
				class="individual-student-name"
				aria-live="polite">
				<h2>{{ selectedStudentName }}</h2>
			</div>
			<pagination
				class="print-hidden student-select"
				label="Student"
				:page="selectedStudentIdx"
				:total="roster && roster.students.length"
				:page-size="1"
				:show-arrow-text="false"
				allow-wrap
				variant="minimal"
				:on-previous-page="previousStudent"
				:on-next-page="nextStudent"></pagination>
		</div>
		<div class="ski-student-header">
			<div class="ski-student-answer ski-student-answer-header wrapper column-headers">
				<div
					class="student-name spacer"
					v-if="resultsTab !== 'response'">
					STUDENT
				</div>
				<div
					class="student-name spacer"
					v-if="resultsTab === 'response'">
					RESPONSE
				</div>
				<div class="answer-column">ANSWER</div>
				<div class="answer-column second-answer-column">ANSWER</div>
				<div class="change-column spacer">CHANGE</div>
			</div>
			<div class="wrapper">
				<div class="ski-student-answer ski-student-answer-header">
					<div class="student-name"></div>
					<form
						@submit.prevent
						class="answer-column validated-form">
						<div class="assessment-select input-wrapper select-wrapper">
							<select
								class="assessment-choice-select"
								v-model="firstActiveRMSID">
								<option
									v-for="a in sortedAssignments"
									:key="a.rmsid"
									:value="a.rmsid"
									:selected="firstActiveRMSID === a.rmsid">
									{{ a.d | date }}
								</option>
							</select>
						</div>
					</form>
					<form
						@submit.prevent
						class="answer-column second-answer-column validated-form">
						<div
							class="text-muted"
							v-if="!sortedAssignments || sortedAssignments.length < 2">
							None
							<button
								class="button -link"
								v-tooltip="'If you assign multiple RMS, you will be able to compare them here.'">
								<info-icon></info-icon>
							</button>
						</div>
						<div
							class="assessment-select input-wrapper select-wrapper"
							v-if="sortedAssignments && sortedAssignments.length >= 2">
							<select
								class="assessment-choice-select"
								:disabled="!sortedAssignments || sortedAssignments.length < 2"
								v-model="secondActiveRMSID">
								<option
									v-if="!sortedAssignments || sortedAssignments.length < 2"
									selected
									value="">
									N/A
								</option>
								<option
									v-for="a in sortedAssignments"
									:key="a.rmsid"
									:value="a.rmsid"
									:selected="secondActiveRMSID === a.rmsid">
									{{ a.d | date }}
								</option>
							</select>
						</div>
					</form>
					<div class="change-column"></div>
				</div>
			</div>
		</div>
		<div class="ski-student-questions">
			<div
				class="ski-question assignment-question"
				v-for="(question, idx) in questions"
				:key="question.text">
				<header class="assignment-question-header">
					<div class="wrapper">
						<div class="assignment-question-header-title">{{ idx + 1 }}. {{ question.text }}</div>
					</div>
				</header>
				<div class="wrapper">
					<template v-if="resultsTab === 'response'">
						<div
							v-for="answer in question.answerMap"
							:key="answer.value"
							class="ski-student-answer">
							<div class="student-answer-value">{{ answer.value }}</div>
							<div class="student-choice">{{ answer.count }}</div>
							<div class="student-choice second-answer-column">{{ sortedAssignments && sortedAssignments.length > 1 ? answer.compareCount : '-' }}</div>
							<div
								class="student-choice change-column"
								:class="{
									'text-muted': sortedAssignments && sortedAssignments.length > 1
								}"
								v-html="sortedAssignments && sortedAssignments.length > 1 ? getChangeCount(answer.count, answer.compareCount) : 'N/A'"></div>
						</div>
					</template>
					<template v-if="resultsTab !== 'response'">
						<div
							v-for="student in question.students"
							:key="student.uid"
							class="ski-student-answer">
							<a
								class="student-name"
								href="javascript:void(0)"
								@click="onStudentClick(student)">
								{{ student.firstName + (student.lastName ? ' ' + student.lastName : '') }}
							</a>
							<div
								v-if="student.submitted"
								class="student-choice">
								{{ student.answer ? student.answer : 'Not answered' }}
							</div>
							<div
								class="student-choice text-muted"
								v-if="!student.submitted">
								Not Submitted
							</div>
							<div
								v-if="secondActiveRMSID && student.compareSubmitted"
								class="student-choice second-answer-column">
								{{ student.compareAnswer ? student.compareAnswer : 'Not answered' }}
							</div>
							<div
								class="student-choice second-answer-column text-muted"
								v-if="secondActiveRMSID && !student.compareSubmitted">
								Not Submitted
							</div>
							<div
								class="student-choice second-answer-column text-muted"
								v-if="!secondActiveRMSID">
								-
							</div>
							<div
								class="student-choice change-column"
								:class="{
									'text-muted': !secondActiveRMSID
								}">
								<template v-if="secondActiveRMSID">
									<span v-html="getChange(question, student)"></span>
								</template>
								<template v-if="!secondActiveRMSID"> N/A </template>
							</div>
						</div>
					</template>
				</div>
			</div>
		</div>
	</div>
</template>
